<ng-container *ngIf="!utils.isPhone else tasksPage;">
    <ion-content>
        <ng-container [ngTemplateOutlet]="tasksPage"></ng-container>
    </ion-content>
</ng-container>

<ng-template #tasksPage>
    <ion-grid class="ion-no-margin">
        <ion-row>
            <ion-col size="12" [sizeXl]="settingsSrv.currentUserRights.canManageTasks ? '7' : '12'">
                <ion-card>
                    <ion-card-header>
                        <ion-toolbar class="task-toolbar" color="none">
                            <ion-card-title>
                                {{ 'tasks.open-tasks' | translate }}

                                <!-- only show this if its not the project page -->
                                <ion-chip
                                    class="dp-ml-s"
                                    [class.ion-hide]="!filterVisible"
                                    [color]="currentFilteredProjects.length == 0 ? 'primary': 'warning'"
                                    (click)="openFilterPopover($event)"
                                >
                                    <ng-container *ngIf="currentFilteredProjects.length == 0; else filterActive"
                                        >{{ 'tasks.filter.filter-heading' | translate }}
                                    </ng-container>
                                    <ng-template #filterActive> {{ 'tasks.filter.change-filter-heading' | translate }} </ng-template>
                                </ion-chip>
                            </ion-card-title>
                            <ion-buttons slot="end" *ngIf="settingsSrv.currentUserRights.canManageTasks">
                                <ion-button color="primary" fill="solid" (click)="onCreateNewTask()">
                                    <fa-icon icon="plus" slot="start"></fa-icon>
                                    {{ 'tasks.new-task-btn' | translate }}
                                </ion-button>
                            </ion-buttons>
                        </ion-toolbar>
                    </ion-card-header>
                    <ion-card-content>
                        <p-table
                            class="tasks-table"
                            [value]="currentOpenTasks"
                            [paginator]="currentOpenTasks.length > 12"
                            [rows]="12"
                            sortField="name"
                            [sortOrder]="1"
                            [loading]="tasksLoading"
                        >
                            <ng-template #header>
                                <tr>
                                    <th pSortableColumn="name" style="width: 35%">
                                        <div class="p-table-sort-th">
                                            {{ 'tasks.table.name' | translate }}
                                            <p-sortIcon field="name" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="workingStatus" style="width: 15%">
                                        <div class="p-table-sort-th ion-justify-content-center">
                                            {{ 'tasks.table.status' | translate }}
                                            <p-sortIcon field="workingStatus" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="deadlineDate" style="width: 15%">
                                        <div class="p-table-sort-th ion-justify-content-center">
                                            {{ 'tasks.table.endDate' | translate }}
                                            <p-sortIcon field="deadlineDate" />
                                        </div>
                                    </th>
                                    <th style="width: 35%"></th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-task>
                                <tr class="task-data-row" (click)="onEditTask(task, 'edit', $event)">
                                    <td>
                                        <div class="task-data-wrap">
                                            <div class="task-info d-flex align-items-center">
                                                <div class="task-status" [ngClass]="workingStatuses[task.workingStatus].severity"></div>
                                                <div class="task-name-wrapper">
                                                    <span class="task-title">{{ task.name }}</span>
                                                    @if ((!projectId) || (projectId && filterVisible)) { @if
                                                    (getProjectInfoById(task.relatedProject); as project) {
                                                    <div class="project-name">
                                                        <span class="project-name-text" [title]="project.name"> {{ project.name }} </span>
                                                        @if (project.projectNumber) {
                                                        <ion-chip class="project-number" [outline]="true" color="primary">
                                                            <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                                            <span class="project-number-text">{{ project.projectNumber }}</span>
                                                        </ion-chip>
                                                        }
                                                    </div>
                                                    } }
                                                </div>
                                                <div class="sync-icon dp-ml-s" *ngIf="!task.synced">
                                                    <fa-icon icon="cloud-upload" class="color-warning" size="lg"></fa-icon>
                                                </div>
                                            </div>
                                            <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                        </div>
                                    </td>
                                    <td class="ion-text-center">
                                        <p-tag
                                            [value]="getStatusName(task.workingStatus)"
                                            [severity]="workingStatuses[task.workingStatus].severity"
                                        />
                                    </td>
                                    @let overdue = task.deadlineDate != null && isOverdue(task);
                                    <td class="ion-text-center" [class.overdue]="overdue">
                                        @if (task.deadlineDate != null) { {{ task.deadlineDate | date: 'dd.MM.yyyy' }} @if (overdue) {
                                        <fa-icon icon="clock"></fa-icon>
                                        } } @else { - }
                                    </td>
                                    <td>
                                        <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                    </td>
                                </tr>
                                <ng-template #taskActions>
                                    <div class="task-actions d-flex ion-align-items-center ion-justify-content-end">
                                        <ng-container
                                            *ngIf="settingsSrv.currentUserRights.canCreateReports && task.relatedProject != null && task.jobs.length > 0 && !(projectId && projectSrv.currentProjectGuestAccess)"
                                        >
                                            <ion-button
                                                size="small"
                                                class="round"
                                                dpTooltip
                                                [tooltipContent]="'tasks.create-report-btn' | translate"
                                                (click)="generateReportForTask(task, $event)"
                                            >
                                                <fa-icon icon="file-spreadsheet" slot="icon-only"></fa-icon>
                                            </ion-button>
                                        </ng-container>
                                        <ion-button
                                            slot="end"
                                            size="small"
                                            fill="solid"
                                            color="primary"
                                            [ngClass]="{'round': utils.mobileViewActive}"
                                            (click)="onEditTask(task, 'edit', $event)"
                                        >
                                            <fa-icon icon="edit" [slot]="utils.mobileViewActive ? 'icon-only' : 'start'"></fa-icon>
                                            <ng-container *ngIf="!utils.mobileViewActive">{{ 'shared.edit' | translate }}</ng-container>
                                        </ion-button>
                                        <ng-container *ngIf="settingsSrv.currentUserRights.canManageTasks">
                                            <ion-button
                                                size="small"
                                                slot="end"
                                                class="round"
                                                fill="solid"
                                                color="danger"
                                                dpTooltip
                                                [tooltipContent]="'tasks.delete-task-btn' | translate"
                                                (click)="onDeleteTask(task, $event)"
                                            >
                                                <fa-icon [icon]="['far', 'trash']"></fa-icon>
                                            </ion-button>
                                        </ng-container>
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-template #emptymessage>
                                <tr>
                                    <td colspan="5">{{ 'tasks.no-tasks' | translate }}</td>
                                </tr>
                            </ng-template>
                        </p-table>

                        @if (this.settingsSrv.getUserRights().hasAccessToFutureTasks && futureOpenTasks.length > 0) {
                        <div class="future-tasks-section dp-mt-m dp-mb-s">
                            <div class="future-tasks-banner">
                                <fa-icon [icon]="['far', 'clock']" class="future-tasks-icon"></fa-icon>
                                <div class="future-tasks-text">
                                    <span class="future-tasks-title"> {{ 'tasks.table.future' | translate }} </span>
                                </div>
                            </div>
                        </div>

                        <p-table
                            class="tasks-table future-tasks-table"
                            [value]="futureOpenTasks"
                            [paginator]="futureOpenTasks.length > 12"
                            [rows]="12"
                            sortField="name"
                            [sortOrder]="1"
                            [loading]="tasksLoading"
                        >
                            <ng-template #header>
                                <tr>
                                    <th pSortableColumn="name" style="width: 35%">
                                        <div class="p-table-sort-th">
                                            {{ 'tasks.table.name' | translate }}
                                            <p-sortIcon field="name" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="workingStatus" style="width: 15%">
                                        <div class="p-table-sort-th ion-justify-content-center">
                                            {{ 'tasks.table.status' | translate }}
                                            <p-sortIcon field="workingStatus" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="startDate" style="width: 15%">
                                        <div class="p-table-sort-th ion-justify-content-center">
                                            {{ 'tasks.table.startDate' | translate }}
                                            <p-sortIcon field="startDate" />
                                        </div>
                                    </th>
                                    <th style="width: 35%"></th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-task>
                                <tr class="task-data-row" (click)="onEditTask(task, 'edit', $event)">
                                    <td>
                                        <div class="task-data-wrap">
                                            <div class="task-info d-flex align-items-center">
                                                <div class="task-status" [ngClass]="workingStatuses[task.workingStatus].severity"></div>
                                                <div class="task-name-wrapper">
                                                    <span class="task-title">{{ task.name }}</span>
                                                    @if ((!projectId) || (projectId && filterVisible)) { @if
                                                    (getProjectInfoById(task.relatedProject); as project) {
                                                    <div class="project-name">
                                                        <span class="project-name-text" [title]="project.name"> {{ project.name }} </span>
                                                        @if (project.projectNumber) {
                                                        <ion-chip class="project-number" [outline]="true" color="primary">
                                                            <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                                            <span class="project-number-text">{{ project.projectNumber }}</span>
                                                        </ion-chip>
                                                        }
                                                    </div>
                                                    } }
                                                </div>
                                                <div class="sync-icon dp-ml-s" *ngIf="!task.synced">
                                                    <fa-icon icon="cloud-upload" class="color-warning" size="lg"></fa-icon>
                                                </div>
                                            </div>
                                            <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                        </div>
                                    </td>
                                    <td class="ion-text-center">
                                        <p-tag
                                            [value]="getStatusName(task.workingStatus)"
                                            [severity]="workingStatuses[task.workingStatus].severity"
                                        />
                                    </td>
                                    <td class="ion-text-center">
                                        {{ task.startDate != null ? (task.startDate | date: 'dd.MM.yyyy') : '-' }}
                                    </td>
                                    <td>
                                        <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                    </td>
                                </tr>
                                <ng-template #taskActions>
                                    <div class="task-actions d-flex ion-align-items-center ion-justify-content-end">
                                        <ng-container
                                            *ngIf="settingsSrv.currentUserRights.canCreateReports && task.relatedProject != null && task.jobs.length > 0 && !(projectId && projectSrv.currentProjectGuestAccess)"
                                        >
                                            <ion-button
                                                size="small"
                                                class="round"
                                                dpTooltip
                                                [tooltipContent]="'tasks.create-report-btn' | translate"
                                                (click)="generateReportForTask(task, $event)"
                                            >
                                                <fa-icon icon="file-spreadsheet" slot="icon-only"></fa-icon>
                                            </ion-button>
                                        </ng-container>
                                        <ion-button
                                            slot="end"
                                            size="small"
                                            fill="solid"
                                            color="primary"
                                            [ngClass]="{'round': utils.mobileViewActive}"
                                            (click)="onEditTask(task, 'edit', $event)"
                                        >
                                            <fa-icon icon="edit" [slot]="utils.mobileViewActive ? 'icon-only' : 'start'"></fa-icon>
                                            <ng-container *ngIf="!utils.mobileViewActive">{{ 'shared.edit' | translate }}</ng-container>
                                        </ion-button>
                                        <ng-container *ngIf="settingsSrv.currentUserRights.canManageTasks">
                                            <ion-button
                                                size="small"
                                                slot="end"
                                                class="round"
                                                fill="solid"
                                                color="danger"
                                                dpTooltip
                                                [tooltipContent]="'tasks.delete-task-btn' | translate"
                                                (click)="onDeleteTask(task, $event)"
                                            >
                                                <fa-icon [icon]="['far', 'trash']"></fa-icon>
                                            </ion-button>
                                        </ng-container>
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-template #emptymessage>
                                <tr>
                                    <td colspan="5">{{ 'tasks.no-tasks' | translate }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                        }
                    </ion-card-content>
                </ion-card>
            </ion-col>
            <ng-container *ngIf="settingsSrv.currentUserRights.canManageTasks">
                <ion-col size="12" size-xl="5">
                    <ion-card>
                        <ion-card-header>
                            <ion-toolbar class="task-toolbar" color="none">
                                <ion-card-title>{{ 'tasks.closed-tasks' | translate }}</ion-card-title>
                            </ion-toolbar>
                        </ion-card-header>
                        <ion-card-content>
                            <p-table
                                class="tasks-table"
                                [value]="doneTasks"
                                [paginator]="doneTasks.length > 12"
                                [rows]="12"
                                sortField="name"
                                [sortOrder]="1"
                                [loading]="tasksLoading"
                            >
                                <ng-template #header>
                                    <tr>
                                        <th pSortableColumn="name" style="width: 40%">
                                            <div class="p-table-sort-th">
                                                {{ 'tasks.table.name' | translate }}
                                                <p-sortIcon field="name" />
                                            </div>
                                        </th>
                                        <th pSortableColumn="completedAt" style="width: 25%">
                                            <div class="p-table-sort-th ion-justify-content-center">
                                                {{ 'tasks.table.completed' | translate }}
                                                <p-sortIcon field="completedAt" />
                                            </div>
                                        </th>
                                        <th style="width: 35%"></th>
                                    </tr>
                                </ng-template>
                                <ng-template #body let-task>
                                    <tr class="task-data-row" (click)="onEditTask(task, 'view', $event)">
                                        <td>
                                            <div class="task-data-wrap">
                                                <div class="task-info d-flex align-items-center">
                                                    <div class="task-status" [ngClass]="workingStatuses[task.workingStatus].severity"></div>
                                                    <div class="task-name-wrapper">
                                                        <span class="task-title">{{ task.name }}</span>
                                                        @if ((!projectId) || (projectId && filterVisible)) { @if
                                                        (getProjectInfoById(task.relatedProject); as project) {
                                                        <div class="project-name">
                                                            <span class="project-name-text" [title]="project.name">
                                                                {{ project.name }}
                                                            </span>
                                                            @if (project.projectNumber) {
                                                            <ion-chip class="project-number" [outline]="true" color="primary">
                                                                <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                                                <span class="project-number-text">{{ project.projectNumber }}</span>
                                                            </ion-chip>
                                                            }
                                                        </div>
                                                        } }
                                                    </div>
                                                    <div class="sync-icon dp-ml-s" *ngIf="!task.synced">
                                                        <fa-icon icon="cloud-upload" class="color-warning" size="lg"></fa-icon>
                                                    </div>
                                                </div>
                                                <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                            </div>
                                        </td>
                                        <td class="ion-text-center">{{ task.completedAt | date: 'dd.MM.yyyy - HH:mm' }}</td>
                                        <td>
                                            <ng-container *ngTemplateOutlet="taskActions"></ng-container>
                                        </td>
                                    </tr>
                                    <ng-template #taskActions>
                                        <div class="task-actions d-flex ion-align-items-center ion-justify-content-end">
                                            <ng-container
                                                *ngIf="settingsSrv.currentUserRights.canCreateReports && task.relatedProject != null && task.jobs.length > 0 && !(projectId && projectSrv.currentProjectGuestAccess)"
                                            >
                                                <ion-button
                                                    size="small"
                                                    class="round"
                                                    dpTooltip
                                                    [tooltipContent]="'tasks.create-report-btn' | translate"
                                                    (click)="generateReportForTask(task, $event)"
                                                >
                                                    <fa-icon icon="file-spreadsheet" slot="icon-only"></fa-icon>
                                                </ion-button>
                                            </ng-container>
                                            <ion-button
                                                slot="end"
                                                size="small"
                                                fill="solid"
                                                color="primary"
                                                [ngClass]="{'round': utils.mobileViewActive}"
                                                (click)="onEditTask(task, 'view', $event)"
                                            >
                                                <fa-icon icon="eye" [slot]="utils.mobileViewActive ? 'icon-only' : 'start'"></fa-icon>
                                                <ng-container *ngIf="!utils.mobileViewActive">{{ 'shared.view' | translate }}</ng-container>
                                            </ion-button>
                                            <ng-container *ngIf="settingsSrv.currentUserRights.canManageTasks">
                                                <ion-button
                                                    slot="end"
                                                    size="small"
                                                    fill="solid"
                                                    color="light"
                                                    class="round"
                                                    dpTooltip
                                                    [tooltipContent]="'tasks.archive-task-btn' | translate"
                                                    (click)="onArchiveTask(task, $event)"
                                                >
                                                    <fa-icon icon="archive" slot="icon-only"></fa-icon>
                                                </ion-button>
                                            </ng-container>
                                        </div>
                                    </ng-template>
                                </ng-template>
                                <ng-template #emptymessage>
                                    <tr>
                                        <td colspan="5">{{ 'tasks.no-tasks' | translate }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ng-container>
        </ion-row>
    </ion-grid>
</ng-template>

<!-- Filter popover -->
<ion-popover size="auto" class="tasks-filter-popover" trigger="tasks-filter-trigger" trigger-action="click" #tasksFilterPopover>
    <ng-template>
        <ion-content class="ion-padding">
            <div class="dp-mb-s">{{ 'tasks.filter.info' | translate }}</div>

            <div class="dp-floating-field" (click)="openProjectSelectionModal()">
                <div class="field-outline-container" [ngClass]="{'no-label': currentFilteredProjects.length == 0}">
                    <div class="field-outline-start"></div>
                    <div class="field-outline-notch">
                        <div class="notch-spacer">{{ 'tasks.filter.choose-projects-input-placeholder' | translate }}</div>
                    </div>
                    <div class="field-outline-end"></div>
                </div>
                <div class="dp-combo-picker-wrap bg-light ion-display-flex ion-align-items-center">
                    <div class="project-picker">
                        <ng-container *ngIf="currentFilteredProjects.length > 0; else projectPlaceholder">
                            @for (projectId of currentFilteredProjects; track projectId) {
                            <div class="selected-project">
                                <span class="remove-project" (click)="removeProjectFromFilterSelection(projectId, $event)">×</span>
                                <span class="project-name">{{ getProjectInfoById(projectId)?.name || projectId }}</span>
                            </div>
                            }
                        </ng-container>
                        <ng-template #projectPlaceholder>
                            <span>{{ 'tasks.filter.choose-projects-input-placeholder' | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="ion-text-end dp-mt-m">
                <ion-button color="warning" fill="clear" (click)="resetCurrentFilters()">{{ 'shared.reset' | translate }}</ion-button>
                <ion-button color="primary" fill="solid" (click)="confirmCurrentFilters()">{{ 'shared.select' | translate }}</ion-button>
            </div>
        </ion-content>
    </ng-template>
</ion-popover>

<!-- SELECT PROJECT MODAL -->
<ion-modal [isOpen]="projectModalVisible" (ionModalDidDismiss)="projectModalVisible = false" class="modal-m stack-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title>{{ 'shared.select' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="projectModalVisible = false">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]="false">
            <app-project-list
                style="height: 100%"
                mode="multi-select"
                [selectedProjectIds]="currentFilteredProjects"
                (multiProjectSelectionConfirmed)="onConfirmProjectSelection($event)"
            ></app-project-list>
        </ion-content>
    </ng-template>
</ion-modal>

<!-- TASK DETAILS DIALOG -->
<app-task-details [projectView]="projectId != null"></app-task-details>
